import React from "react";
import { getLibelleByIdInIIdLibelle, isNumeric, typeDemandeMessageListMarques, typeDemandeMessageListNotices } from "../../config/helpers";

interface IProps {
  Item?: string;
}

const HtmlRenderTypeDemandeNoticeMarqueBO: React.FC<IProps> = ({ Item }) => {
  return (
    <span >
      {" "}
      {Item && isNumeric(Item) && getLibelleByIdInIIdLibelle(Number(Item),typeDemandeMessageListMarques.concat(typeDemandeMessageListNotices))}
    </span>
  );
};

export default HtmlRenderTypeDemandeNoticeMarqueBO;
